import { Textarea } from '@/components/ui'
import SectionForm, { useFormContext } from '../SectionForm'

const FormContent = () => {
  const { control } = useFormContext()

  return (
    <>
      <div className="flex flex-col items-center gap-4">
        <Textarea.Form name="info_diverses" control={control} className="h-[25vh]" />
      </div>
    </>
  )
}

const Form = ({ title = "", onClose = () => {}, onSuccess = () => {} }) => {
  return (
    <SectionForm
      title={title}
      columns={1}
      onClose={onClose}
      onSuccess={onSuccess}
      fields={["info_diverses"]}
    >
      <FormContent />
    </SectionForm>
  )
}

export default Form